export default {


    CONSTANT: 'constant',
    ENUMERATE: 'enumerate',
    VARIABLE: 'variable',
    INSTANCE: 'instance'
}